import { CompaniesPermissions } from "./company-management.orders.permissions";

export class CompanyManagementPermissions {
  static Companies = CompaniesPermissions?.Permissions;
}

export function getCompanyManagementModuleName() {
  return 'CompaniesManagement';
}